import React, { useEffect } from "react";
import ContadoresTemplate from "../components/templates/ContadoresTemplate";
import { useNavigate } from "react-router-dom";
import { useSession } from "../context/SessionContext";

const Contadores = () => {
    const { user } = useSession();
    const navigate = useNavigate();
    
    useEffect(() => {
        if (user && user.role !== "Admin") {
            navigate("/dashboard");
        }
    }, [user, navigate]);
    
    if (!user || user.role !== "Admin") {
        return null;
    }
    
    return <ContadoresTemplate/>;
};

export default Contadores;